// @ts-nocheck
const popup = {
  data () {
    return {
      visible: false
    }
  },

  computed: {
    dialogVisible: {
      get: function () {
        return this.visible
      },
      set: function (newValue) {
        this.visible = newValue
      }
    }
  }
}

export default popup
